import { createSlice } from "@reduxjs/toolkit";
import { DashboardThunk } from "../../middlewares/dashboard";

const initialState = {
  loading: false,
  loadingCount: 0,
  isUpdate: false,
  dashboardData: {},
  currentRequestId: null,
};

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    isUpdate(state) {
      state.isUpdate = !state;
    },
    startLoading(state) {
      state.loadingCount += 1;
      state.loading = state.loadingCount > 0;
    },
    stopLoading(state) {
      state.loadingCount = Math.max(0, state.loadingCount - 1);
      state.loading = state.loadingCount > 0;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(DashboardThunk.pending, (state, action) => {
        state.currentRequestId = action.meta.requestId;
        state.loadingCount += 1;
        state.loading = state.loadingCount > 0;
      })
      .addCase(DashboardThunk.fulfilled, (state, action) => {
        if (state.currentRequestId === action.meta.requestId) {
          state.dashboardData = action.payload;
          state.currentRequestId = null;
        }
        state.loadingCount = Math.max(0, state.loadingCount - 1);
        state.loading = state.loadingCount > 0;
      })
      .addCase(DashboardThunk.rejected, (state) => {
        state.loadingCount = Math.max(0, state.loadingCount - 1);
        state.loading = state.loadingCount > 0;
      });
  },
});

export default dashboardSlice.reducer;
export const { setAuthUserId, startLoading, stopLoading } =
  dashboardSlice.actions;
